// See environment.ts for doc.
import { EnvironmentInterface } from './environment-interface';

export const managerEnvironmentCommon: EnvironmentInterface = {
  production: true,
  gqlUrl: '/graphql',
  stsServer: window.location.origin,
  authClientId: 'onep-manager-ui',
  organizationAsAdmin: {
    // [POC]
    authClientId: 'onep-admin-ui', // auth client id if shared-info detects the admin is using the portal in a "admin-as-manager" mode
    subDomainRegex:
      /^(admin|[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}).*\.(wedoogift|glady)\.com$/,
  },
  features: {
    organization: true,
    // [POC] Enable admin to access the portal (manager) with for a given organization (on which they might not be managers):
    // "admin-as-manager" mode
    organizationAsAdmin: true,
    admin: false,
  },
  notCustomUrl: [
    'https://manager.qa.tech.glady.com',
    'https://manager.demo.tech.glady.com',
    'https://manager.prod.tech.glady.com',
    'https://manager.integration.tech.glady.com',
    'https://manager.wedoogift.com',
    'https://site.glady.com',
    'https://onep-manager.integration.onep.wedoogift.com',
    'https://onep-manager.qa.onep.wedoogift.com',
    'https://onep-manager.demo.onep.wedoogift.com',
  ],
  personalizationRedirection: false,
  mobileAppUrl: undefined,
  gtmConfig: undefined,
  platform: 'manager',
};
